import Enum from '../interfaces/IEnum';

export const TieTypes: Enum = {
    enum: {
        NOTIE: 0,
        TIEPENDDING: 1,
        TIEORDERED: 2
    }
};
